(function () {
  "use strict";

  /* ---------- scroll reveal (replaces Framer Motion whileInView) ---------- */
  function initReveal() {
    var items = document.querySelectorAll(".reveal");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- header scroll state + mobile nav ---------- */
  function initHeader() {
    var header = document.querySelector("[data-dn-header]");
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 12) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var burger = header.querySelector("[data-dn-burger]");
    var mobileNav = header.querySelector("[data-dn-mobile-nav]");
    var iconMenu = header.querySelector("[data-icon-menu]");
    var iconClose = header.querySelector("[data-icon-close]");
    if (burger && mobileNav) {
      burger.addEventListener("click", function () {
        var isOpen = mobileNav.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        if (iconMenu && iconClose) {
          iconMenu.style.display = isOpen ? "none" : "";
          iconClose.style.display = isOpen ? "" : "none";
        }
      });
      mobileNav.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", function () {
          mobileNav.classList.remove("is-open");
          burger.setAttribute("aria-expanded", "false");
          if (iconMenu && iconClose) {
            iconMenu.style.display = "";
            iconClose.style.display = "none";
          }
        });
      });
    }
  }

  /* ---------- sticky buy bar ---------- */
  function initStickyBuy() {
    var bar = document.querySelector("[data-dn-sticky-buy]");
    if (!bar) return;
    var onScroll = function () {
      if (window.scrollY > 600) bar.classList.add("is-visible");
      else bar.classList.remove("is-visible");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- FAQ accordion (native, no JS framework) ---------- */
  function initAccordion() {
    document.querySelectorAll("[data-dn-accordion]").forEach(function (accordion) {
      var items = accordion.querySelectorAll(".dn-accordion-item");
      items.forEach(function (item) {
        var trigger = item.querySelector(".dn-accordion-trigger");
        var content = item.querySelector(".dn-accordion-content");
        var inner = content.querySelector(".dn-accordion-content__inner");
        if (!trigger || !content) return;
        trigger.addEventListener("click", function () {
          var isOpen = item.classList.contains("is-open");
          items.forEach(function (other) {
            other.classList.remove("is-open");
            var oc = other.querySelector(".dn-accordion-content");
            if (oc) oc.style.maxHeight = "0px";
            var ot = other.querySelector(".dn-accordion-trigger");
            if (ot) ot.setAttribute("aria-expanded", "false");
          });
          if (!isOpen) {
            item.classList.add("is-open");
            content.style.maxHeight = inner.scrollHeight + "px";
            trigger.setAttribute("aria-expanded", "true");
          }
        });
      });
    });
  }

  /* ---------- cart count badge (fetched on load, updated after add) ---------- */
  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("is-visible", count > 0);
    });
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + "cart.js" : "/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---------- Ajax add-to-cart for every [data-dn-product-form] ---------- */
  function initProductForms() {
    var forms = document.querySelectorAll("[data-dn-product-form]");
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var button = form.querySelector("[data-dn-submit]");
        var errorEl = form.querySelector("[data-dn-form-error]");
        if (errorEl) errorEl.textContent = "";
        if (button) {
          button.disabled = true;
          button.dataset.originalText = button.dataset.originalText || button.textContent;
          button.textContent = button.getAttribute("data-loading-text") || "Ajout...";
        }

        var formData = new FormData(form);

        fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function () {
            refreshCartCount();
            document.dispatchEvent(new CustomEvent("dn:cart:added"));
            if (button) {
              button.textContent = button.getAttribute("data-success-text") || "Ajouté ✓";
            }
            var redirect = form.getAttribute("data-redirect-to-cart");
            if (redirect === "true") {
              window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_url : "/cart";
              return;
            }
            setTimeout(function () {
              if (button) {
                button.disabled = false;
                button.textContent = button.dataset.originalText;
              }
            }, 1800);
          })
          .catch(function (err) {
            if (errorEl) errorEl.textContent = (err && err.description) || "Impossible d'ajouter ce produit au panier.";
            if (button) {
              button.disabled = false;
              button.textContent = button.dataset.originalText;
            }
          });
      });
    });
  }

  /* ---------- generic scroll-to-section on any [data-dn-buy] outside forms ---------- */
  function initBuyShortcuts() {
    document.querySelectorAll("[data-dn-scroll-to-buy]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = document.querySelector("[data-dn-product-form]");
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initHeader();
    initStickyBuy();
    initAccordion();
    initProductForms();
    initBuyShortcuts();
    refreshCartCount();
  });
})();
